import _slicedToArray from "/home/runner/work/react/react/docs/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _classCallCheck from "/home/runner/work/react/react/docs/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/react/react/docs/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/home/runner/work/react/react/docs/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/home/runner/work/react/react/docs/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/runner/work/react/react/docs/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/react/react/docs/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _wrapNativeSuper from "/home/runner/work/react/react/docs/node_modules/@babel/runtime/helpers/esm/wrapNativeSuper";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var __classPrivateFieldGet = this && this.__classPrivateFieldGet || function (receiver, state, kind, f) {
  if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
  if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
  return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};

var _MarkdownHeaderButtonElement_instances, _MarkdownHeaderButtonElement_setLevelStyle;

var buttonSelectors = ['[data-md-button]', 'md-header', 'md-bold', 'md-italic', 'md-quote', 'md-code', 'md-link', 'md-image', 'md-unordered-list', 'md-ordered-list', 'md-task-list', 'md-mention', 'md-ref', 'md-strikethrough'];

function getButtons(toolbar) {
  var els = [];

  var _iterator = _createForOfIteratorHelper(toolbar.querySelectorAll(buttonSelectors.join(', '))),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var button = _step.value;
      if (button.hidden || button.offsetWidth <= 0 && button.offsetHeight <= 0) continue;
      if (button.closest('markdown-toolbar') === toolbar) els.push(button);
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return els;
}

function keydown(fn) {
  return function (event) {
    if (event.key === ' ' || event.key === 'Enter') {
      event.preventDefault();
      fn(event);
    }
  };
}

var styles = new WeakMap();

var MarkdownButtonElement = /*#__PURE__*/function (_HTMLElement) {
  _inherits(MarkdownButtonElement, _HTMLElement);

  var _super = _createSuper(MarkdownButtonElement);

  function MarkdownButtonElement() {
    var _this;

    _classCallCheck(this, MarkdownButtonElement);

    _this = _super.call(this);

    var apply = function apply() {
      var style = styles.get(_assertThisInitialized(_this));
      if (!style) return;
      applyStyle(_assertThisInitialized(_this), style);
    };

    _this.addEventListener('keydown', keydown(apply));

    _this.addEventListener('click', apply);

    return _this;
  }

  _createClass(MarkdownButtonElement, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      if (!this.hasAttribute('role')) {
        this.setAttribute('role', 'button');
      }
    }
  }, {
    key: "click",
    value: function click() {
      var style = styles.get(this);
      if (!style) return;
      applyStyle(this, style);
    }
  }]);

  return MarkdownButtonElement;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));

var MarkdownHeaderButtonElement = /*#__PURE__*/function (_MarkdownButtonElemen) {
  _inherits(MarkdownHeaderButtonElement, _MarkdownButtonElemen);

  var _super2 = _createSuper(MarkdownHeaderButtonElement);

  function MarkdownHeaderButtonElement() {
    var _this2;

    _classCallCheck(this, MarkdownHeaderButtonElement);

    _this2 = _super2.apply(this, arguments);

    _MarkdownHeaderButtonElement_instances.add(_assertThisInitialized(_this2));

    return _this2;
  }

  _createClass(MarkdownHeaderButtonElement, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      var level = parseInt(this.getAttribute('level') || '3', 10);

      __classPrivateFieldGet(this, _MarkdownHeaderButtonElement_instances, "m", _MarkdownHeaderButtonElement_setLevelStyle).call(this, level);
    }
  }, {
    key: "attributeChangedCallback",
    value: function attributeChangedCallback(name, oldValue, newValue) {
      if (name !== 'level') return;
      var level = parseInt(newValue || '3', 10);

      __classPrivateFieldGet(this, _MarkdownHeaderButtonElement_instances, "m", _MarkdownHeaderButtonElement_setLevelStyle).call(this, level);
    }
  }], [{
    key: "observedAttributes",
    get: function get() {
      return ['level'];
    }
  }]);

  return MarkdownHeaderButtonElement;
}(MarkdownButtonElement);

_MarkdownHeaderButtonElement_instances = new WeakSet(), _MarkdownHeaderButtonElement_setLevelStyle = function _MarkdownHeaderButtonElement_setLevelStyle(level) {
  if (level < 1 || level > 6) {
    return;
  }

  var prefix = "".concat('#'.repeat(level), " ");
  styles.set(this, {
    prefix: prefix
  });
};

if (!window.customElements.get('md-header')) {
  window.MarkdownHeaderButtonElement = MarkdownHeaderButtonElement;
  window.customElements.define('md-header', MarkdownHeaderButtonElement);
}

var MarkdownBoldButtonElement = /*#__PURE__*/function (_MarkdownButtonElemen2) {
  _inherits(MarkdownBoldButtonElement, _MarkdownButtonElemen2);

  var _super3 = _createSuper(MarkdownBoldButtonElement);

  function MarkdownBoldButtonElement() {
    _classCallCheck(this, MarkdownBoldButtonElement);

    return _super3.apply(this, arguments);
  }

  _createClass(MarkdownBoldButtonElement, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      styles.set(this, {
        prefix: '**',
        suffix: '**',
        trimFirst: true
      });
    }
  }]);

  return MarkdownBoldButtonElement;
}(MarkdownButtonElement);

if (!window.customElements.get('md-bold')) {
  window.MarkdownBoldButtonElement = MarkdownBoldButtonElement;
  window.customElements.define('md-bold', MarkdownBoldButtonElement);
}

var MarkdownItalicButtonElement = /*#__PURE__*/function (_MarkdownButtonElemen3) {
  _inherits(MarkdownItalicButtonElement, _MarkdownButtonElemen3);

  var _super4 = _createSuper(MarkdownItalicButtonElement);

  function MarkdownItalicButtonElement() {
    _classCallCheck(this, MarkdownItalicButtonElement);

    return _super4.apply(this, arguments);
  }

  _createClass(MarkdownItalicButtonElement, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      styles.set(this, {
        prefix: '_',
        suffix: '_',
        trimFirst: true
      });
    }
  }]);

  return MarkdownItalicButtonElement;
}(MarkdownButtonElement);

if (!window.customElements.get('md-italic')) {
  window.MarkdownItalicButtonElement = MarkdownItalicButtonElement;
  window.customElements.define('md-italic', MarkdownItalicButtonElement);
}

var MarkdownQuoteButtonElement = /*#__PURE__*/function (_MarkdownButtonElemen4) {
  _inherits(MarkdownQuoteButtonElement, _MarkdownButtonElemen4);

  var _super5 = _createSuper(MarkdownQuoteButtonElement);

  function MarkdownQuoteButtonElement() {
    _classCallCheck(this, MarkdownQuoteButtonElement);

    return _super5.apply(this, arguments);
  }

  _createClass(MarkdownQuoteButtonElement, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      styles.set(this, {
        prefix: '> ',
        multiline: true,
        surroundWithNewlines: true
      });
    }
  }]);

  return MarkdownQuoteButtonElement;
}(MarkdownButtonElement);

if (!window.customElements.get('md-quote')) {
  window.MarkdownQuoteButtonElement = MarkdownQuoteButtonElement;
  window.customElements.define('md-quote', MarkdownQuoteButtonElement);
}

var MarkdownCodeButtonElement = /*#__PURE__*/function (_MarkdownButtonElemen5) {
  _inherits(MarkdownCodeButtonElement, _MarkdownButtonElemen5);

  var _super6 = _createSuper(MarkdownCodeButtonElement);

  function MarkdownCodeButtonElement() {
    _classCallCheck(this, MarkdownCodeButtonElement);

    return _super6.apply(this, arguments);
  }

  _createClass(MarkdownCodeButtonElement, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      styles.set(this, {
        prefix: '`',
        suffix: '`',
        blockPrefix: '```',
        blockSuffix: '```'
      });
    }
  }]);

  return MarkdownCodeButtonElement;
}(MarkdownButtonElement);

if (!window.customElements.get('md-code')) {
  window.MarkdownCodeButtonElement = MarkdownCodeButtonElement;
  window.customElements.define('md-code', MarkdownCodeButtonElement);
}

var MarkdownLinkButtonElement = /*#__PURE__*/function (_MarkdownButtonElemen6) {
  _inherits(MarkdownLinkButtonElement, _MarkdownButtonElemen6);

  var _super7 = _createSuper(MarkdownLinkButtonElement);

  function MarkdownLinkButtonElement() {
    _classCallCheck(this, MarkdownLinkButtonElement);

    return _super7.apply(this, arguments);
  }

  _createClass(MarkdownLinkButtonElement, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      styles.set(this, {
        prefix: '[',
        suffix: '](url)',
        replaceNext: 'url',
        scanFor: 'https?://'
      });
    }
  }]);

  return MarkdownLinkButtonElement;
}(MarkdownButtonElement);

if (!window.customElements.get('md-link')) {
  window.MarkdownLinkButtonElement = MarkdownLinkButtonElement;
  window.customElements.define('md-link', MarkdownLinkButtonElement);
}

var MarkdownImageButtonElement = /*#__PURE__*/function (_MarkdownButtonElemen7) {
  _inherits(MarkdownImageButtonElement, _MarkdownButtonElemen7);

  var _super8 = _createSuper(MarkdownImageButtonElement);

  function MarkdownImageButtonElement() {
    _classCallCheck(this, MarkdownImageButtonElement);

    return _super8.apply(this, arguments);
  }

  _createClass(MarkdownImageButtonElement, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      styles.set(this, {
        prefix: '![',
        suffix: '](url)',
        replaceNext: 'url',
        scanFor: 'https?://'
      });
    }
  }]);

  return MarkdownImageButtonElement;
}(MarkdownButtonElement);

if (!window.customElements.get('md-image')) {
  window.MarkdownImageButtonElement = MarkdownImageButtonElement;
  window.customElements.define('md-image', MarkdownImageButtonElement);
}

var MarkdownUnorderedListButtonElement = /*#__PURE__*/function (_MarkdownButtonElemen8) {
  _inherits(MarkdownUnorderedListButtonElement, _MarkdownButtonElemen8);

  var _super9 = _createSuper(MarkdownUnorderedListButtonElement);

  function MarkdownUnorderedListButtonElement() {
    _classCallCheck(this, MarkdownUnorderedListButtonElement);

    return _super9.apply(this, arguments);
  }

  _createClass(MarkdownUnorderedListButtonElement, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      styles.set(this, {
        prefix: '- ',
        multiline: true,
        unorderedList: true
      });
    }
  }]);

  return MarkdownUnorderedListButtonElement;
}(MarkdownButtonElement);

if (!window.customElements.get('md-unordered-list')) {
  window.MarkdownUnorderedListButtonElement = MarkdownUnorderedListButtonElement;
  window.customElements.define('md-unordered-list', MarkdownUnorderedListButtonElement);
}

var MarkdownOrderedListButtonElement = /*#__PURE__*/function (_MarkdownButtonElemen9) {
  _inherits(MarkdownOrderedListButtonElement, _MarkdownButtonElemen9);

  var _super10 = _createSuper(MarkdownOrderedListButtonElement);

  function MarkdownOrderedListButtonElement() {
    _classCallCheck(this, MarkdownOrderedListButtonElement);

    return _super10.apply(this, arguments);
  }

  _createClass(MarkdownOrderedListButtonElement, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      styles.set(this, {
        prefix: '1. ',
        multiline: true,
        orderedList: true
      });
    }
  }]);

  return MarkdownOrderedListButtonElement;
}(MarkdownButtonElement);

if (!window.customElements.get('md-ordered-list')) {
  window.MarkdownOrderedListButtonElement = MarkdownOrderedListButtonElement;
  window.customElements.define('md-ordered-list', MarkdownOrderedListButtonElement);
}

var MarkdownTaskListButtonElement = /*#__PURE__*/function (_MarkdownButtonElemen10) {
  _inherits(MarkdownTaskListButtonElement, _MarkdownButtonElemen10);

  var _super11 = _createSuper(MarkdownTaskListButtonElement);

  function MarkdownTaskListButtonElement() {
    _classCallCheck(this, MarkdownTaskListButtonElement);

    return _super11.apply(this, arguments);
  }

  _createClass(MarkdownTaskListButtonElement, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      styles.set(this, {
        prefix: '- [ ] ',
        multiline: true,
        surroundWithNewlines: true
      });
    }
  }]);

  return MarkdownTaskListButtonElement;
}(MarkdownButtonElement);

if (!window.customElements.get('md-task-list')) {
  window.MarkdownTaskListButtonElement = MarkdownTaskListButtonElement;
  window.customElements.define('md-task-list', MarkdownTaskListButtonElement);
}

var MarkdownMentionButtonElement = /*#__PURE__*/function (_MarkdownButtonElemen11) {
  _inherits(MarkdownMentionButtonElement, _MarkdownButtonElemen11);

  var _super12 = _createSuper(MarkdownMentionButtonElement);

  function MarkdownMentionButtonElement() {
    _classCallCheck(this, MarkdownMentionButtonElement);

    return _super12.apply(this, arguments);
  }

  _createClass(MarkdownMentionButtonElement, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      styles.set(this, {
        prefix: '@',
        prefixSpace: true
      });
    }
  }]);

  return MarkdownMentionButtonElement;
}(MarkdownButtonElement);

if (!window.customElements.get('md-mention')) {
  window.MarkdownMentionButtonElement = MarkdownMentionButtonElement;
  window.customElements.define('md-mention', MarkdownMentionButtonElement);
}

var MarkdownRefButtonElement = /*#__PURE__*/function (_MarkdownButtonElemen12) {
  _inherits(MarkdownRefButtonElement, _MarkdownButtonElemen12);

  var _super13 = _createSuper(MarkdownRefButtonElement);

  function MarkdownRefButtonElement() {
    _classCallCheck(this, MarkdownRefButtonElement);

    return _super13.apply(this, arguments);
  }

  _createClass(MarkdownRefButtonElement, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      styles.set(this, {
        prefix: '#',
        prefixSpace: true
      });
    }
  }]);

  return MarkdownRefButtonElement;
}(MarkdownButtonElement);

if (!window.customElements.get('md-ref')) {
  window.MarkdownRefButtonElement = MarkdownRefButtonElement;
  window.customElements.define('md-ref', MarkdownRefButtonElement);
}

var MarkdownStrikethroughButtonElement = /*#__PURE__*/function (_MarkdownButtonElemen13) {
  _inherits(MarkdownStrikethroughButtonElement, _MarkdownButtonElemen13);

  var _super14 = _createSuper(MarkdownStrikethroughButtonElement);

  function MarkdownStrikethroughButtonElement() {
    _classCallCheck(this, MarkdownStrikethroughButtonElement);

    return _super14.apply(this, arguments);
  }

  _createClass(MarkdownStrikethroughButtonElement, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      styles.set(this, {
        prefix: '~~',
        suffix: '~~',
        trimFirst: true
      });
    }
  }]);

  return MarkdownStrikethroughButtonElement;
}(MarkdownButtonElement);

if (!window.customElements.get('md-strikethrough')) {
  window.MarkdownStrikethroughButtonElement = MarkdownStrikethroughButtonElement;
  window.customElements.define('md-strikethrough', MarkdownStrikethroughButtonElement);
}

var MarkdownToolbarElement = /*#__PURE__*/function (_HTMLElement2) {
  _inherits(MarkdownToolbarElement, _HTMLElement2);

  var _super15 = _createSuper(MarkdownToolbarElement);

  function MarkdownToolbarElement() {
    _classCallCheck(this, MarkdownToolbarElement);

    return _super15.apply(this, arguments);
  }

  _createClass(MarkdownToolbarElement, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      if (!this.hasAttribute('role')) {
        this.setAttribute('role', 'toolbar');
      }

      this.addEventListener('keydown', focusKeydown);
      this.setAttribute('tabindex', '0');
      this.addEventListener('focus', onToolbarFocus, {
        once: true
      });
    }
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      this.removeEventListener('keydown', focusKeydown);
    }
  }, {
    key: "field",
    get: function get() {
      var id = this.getAttribute('for');
      if (!id) return null;
      var root = 'getRootNode' in this ? this.getRootNode() : document;
      var field;

      if (root instanceof Document || root instanceof ShadowRoot) {
        field = root.getElementById(id);
      }

      return field instanceof HTMLTextAreaElement ? field : null;
    }
  }]);

  return MarkdownToolbarElement;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));

function onToolbarFocus(_ref) {
  var target = _ref.target;
  if (!(target instanceof Element)) return;
  target.removeAttribute('tabindex');
  var tabindex = '0';

  var _iterator2 = _createForOfIteratorHelper(getButtons(target)),
      _step2;

  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var button = _step2.value;
      button.setAttribute('tabindex', tabindex);

      if (tabindex === '0') {
        button.focus();
        tabindex = '-1';
      }
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
}

function focusKeydown(event) {
  var key = event.key;
  if (key !== 'ArrowRight' && key !== 'ArrowLeft' && key !== 'Home' && key !== 'End') return;
  var toolbar = event.currentTarget;
  if (!(toolbar instanceof HTMLElement)) return;
  var buttons = getButtons(toolbar);
  var index = buttons.indexOf(event.target);
  var length = buttons.length;
  if (index === -1) return;
  var n = 0;
  if (key === 'ArrowLeft') n = index - 1;
  if (key === 'ArrowRight') n = index + 1;
  if (key === 'End') n = length - 1;
  if (n < 0) n = length - 1;
  if (n > length - 1) n = 0;

  for (var i = 0; i < length; i += 1) {
    buttons[i].setAttribute('tabindex', i === n ? '0' : '-1');
  }

  event.preventDefault();
  buttons[n].focus();
}

if (!window.customElements.get('markdown-toolbar')) {
  window.MarkdownToolbarElement = MarkdownToolbarElement;
  window.customElements.define('markdown-toolbar', MarkdownToolbarElement);
}

function isMultipleLines(string) {
  return string.trim().split('\n').length > 1;
}

function repeat(string, n) {
  return Array(n + 1).join(string);
}

function wordSelectionStart(text, i) {
  var index = i;

  while (text[index] && text[index - 1] != null && !text[index - 1].match(/\s/)) {
    index--;
  }

  return index;
}

function wordSelectionEnd(text, i, multiline) {
  var index = i;
  var breakpoint = multiline ? /\n/ : /\s/;

  while (text[index] && !text[index].match(breakpoint)) {
    index++;
  }

  return index;
}

var canInsertText = null;

function insertText(textarea, _ref2) {
  var text = _ref2.text,
      selectionStart = _ref2.selectionStart,
      selectionEnd = _ref2.selectionEnd;
  var originalSelectionStart = textarea.selectionStart;
  var before = textarea.value.slice(0, originalSelectionStart);
  var after = textarea.value.slice(textarea.selectionEnd);

  if (canInsertText === null || canInsertText === true) {
    textarea.contentEditable = 'true';

    try {
      canInsertText = document.execCommand('insertText', false, text);
    } catch (error) {
      canInsertText = false;
    }

    textarea.contentEditable = 'false';
  }

  if (canInsertText && !textarea.value.slice(0, textarea.selectionStart).endsWith(text)) {
    canInsertText = false;
  }

  if (!canInsertText) {
    try {
      document.execCommand('ms-beginUndoUnit');
    } catch (e) {}

    textarea.value = before + text + after;

    try {
      document.execCommand('ms-endUndoUnit');
    } catch (e) {}

    textarea.dispatchEvent(new CustomEvent('input', {
      bubbles: true,
      cancelable: true
    }));
  }

  if (selectionStart != null && selectionEnd != null) {
    textarea.setSelectionRange(selectionStart, selectionEnd);
  } else {
    textarea.setSelectionRange(originalSelectionStart, textarea.selectionEnd);
  }
}

function styleSelectedText(textarea, styleArgs) {
  var text = textarea.value.slice(textarea.selectionStart, textarea.selectionEnd);
  var result;

  if (styleArgs.orderedList || styleArgs.unorderedList) {
    result = listStyle(textarea, styleArgs);
  } else if (styleArgs.multiline && isMultipleLines(text)) {
    result = multilineStyle(textarea, styleArgs);
  } else {
    result = blockStyle(textarea, styleArgs);
  }

  insertText(textarea, result);
}

function expandSelectionToLine(textarea) {
  var lines = textarea.value.split('\n');
  var counter = 0;

  for (var index = 0; index < lines.length; index++) {
    var lineLength = lines[index].length + 1;

    if (textarea.selectionStart >= counter && textarea.selectionStart < counter + lineLength) {
      textarea.selectionStart = counter;
    }

    if (textarea.selectionEnd >= counter && textarea.selectionEnd < counter + lineLength) {
      textarea.selectionEnd = counter + lineLength - 1;
    }

    counter += lineLength;
  }
}

function expandSelectedText(textarea, prefixToUse, suffixToUse) {
  var multiline = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

  if (textarea.selectionStart === textarea.selectionEnd) {
    textarea.selectionStart = wordSelectionStart(textarea.value, textarea.selectionStart);
    textarea.selectionEnd = wordSelectionEnd(textarea.value, textarea.selectionEnd, multiline);
  } else {
    var expandedSelectionStart = textarea.selectionStart - prefixToUse.length;
    var expandedSelectionEnd = textarea.selectionEnd + suffixToUse.length;
    var beginsWithPrefix = textarea.value.slice(expandedSelectionStart, textarea.selectionStart) === prefixToUse;
    var endsWithSuffix = textarea.value.slice(textarea.selectionEnd, expandedSelectionEnd) === suffixToUse;

    if (beginsWithPrefix && endsWithSuffix) {
      textarea.selectionStart = expandedSelectionStart;
      textarea.selectionEnd = expandedSelectionEnd;
    }
  }

  return textarea.value.slice(textarea.selectionStart, textarea.selectionEnd);
}

function newlinesToSurroundSelectedText(textarea) {
  var beforeSelection = textarea.value.slice(0, textarea.selectionStart);
  var afterSelection = textarea.value.slice(textarea.selectionEnd);
  var breaksBefore = beforeSelection.match(/\n*$/);
  var breaksAfter = afterSelection.match(/^\n*/);
  var newlinesBeforeSelection = breaksBefore ? breaksBefore[0].length : 0;
  var newlinesAfterSelection = breaksAfter ? breaksAfter[0].length : 0;
  var newlinesToAppend;
  var newlinesToPrepend;

  if (beforeSelection.match(/\S/) && newlinesBeforeSelection < 2) {
    newlinesToAppend = repeat('\n', 2 - newlinesBeforeSelection);
  }

  if (afterSelection.match(/\S/) && newlinesAfterSelection < 2) {
    newlinesToPrepend = repeat('\n', 2 - newlinesAfterSelection);
  }

  if (newlinesToAppend == null) {
    newlinesToAppend = '';
  }

  if (newlinesToPrepend == null) {
    newlinesToPrepend = '';
  }

  return {
    newlinesToAppend: newlinesToAppend,
    newlinesToPrepend: newlinesToPrepend
  };
}

function blockStyle(textarea, arg) {
  var newlinesToAppend;
  var newlinesToPrepend;
  var prefix = arg.prefix,
      suffix = arg.suffix,
      blockPrefix = arg.blockPrefix,
      blockSuffix = arg.blockSuffix,
      replaceNext = arg.replaceNext,
      prefixSpace = arg.prefixSpace,
      scanFor = arg.scanFor,
      surroundWithNewlines = arg.surroundWithNewlines;
  var originalSelectionStart = textarea.selectionStart;
  var originalSelectionEnd = textarea.selectionEnd;
  var selectedText = textarea.value.slice(textarea.selectionStart, textarea.selectionEnd);
  var prefixToUse = isMultipleLines(selectedText) && blockPrefix.length > 0 ? "".concat(blockPrefix, "\n") : prefix;
  var suffixToUse = isMultipleLines(selectedText) && blockSuffix.length > 0 ? "\n".concat(blockSuffix) : suffix;

  if (prefixSpace) {
    var beforeSelection = textarea.value[textarea.selectionStart - 1];

    if (textarea.selectionStart !== 0 && beforeSelection != null && !beforeSelection.match(/\s/)) {
      prefixToUse = " ".concat(prefixToUse);
    }
  }

  selectedText = expandSelectedText(textarea, prefixToUse, suffixToUse, arg.multiline);
  var selectionStart = textarea.selectionStart;
  var selectionEnd = textarea.selectionEnd;
  var hasReplaceNext = replaceNext.length > 0 && suffixToUse.indexOf(replaceNext) > -1 && selectedText.length > 0;

  if (surroundWithNewlines) {
    var ref = newlinesToSurroundSelectedText(textarea);
    newlinesToAppend = ref.newlinesToAppend;
    newlinesToPrepend = ref.newlinesToPrepend;
    prefixToUse = newlinesToAppend + prefix;
    suffixToUse += newlinesToPrepend;
  }

  if (selectedText.startsWith(prefixToUse) && selectedText.endsWith(suffixToUse)) {
    var replacementText = selectedText.slice(prefixToUse.length, selectedText.length - suffixToUse.length);

    if (originalSelectionStart === originalSelectionEnd) {
      var position = originalSelectionStart - prefixToUse.length;
      position = Math.max(position, selectionStart);
      position = Math.min(position, selectionStart + replacementText.length);
      selectionStart = selectionEnd = position;
    } else {
      selectionEnd = selectionStart + replacementText.length;
    }

    return {
      text: replacementText,
      selectionStart: selectionStart,
      selectionEnd: selectionEnd
    };
  } else if (!hasReplaceNext) {
    var _replacementText = prefixToUse + selectedText + suffixToUse;

    selectionStart = originalSelectionStart + prefixToUse.length;
    selectionEnd = originalSelectionEnd + prefixToUse.length;
    var whitespaceEdges = selectedText.match(/^\s*|\s*$/g);

    if (arg.trimFirst && whitespaceEdges) {
      var leadingWhitespace = whitespaceEdges[0] || '';
      var trailingWhitespace = whitespaceEdges[1] || '';
      _replacementText = leadingWhitespace + prefixToUse + selectedText.trim() + suffixToUse + trailingWhitespace;
      selectionStart += leadingWhitespace.length;
      selectionEnd -= trailingWhitespace.length;
    }

    return {
      text: _replacementText,
      selectionStart: selectionStart,
      selectionEnd: selectionEnd
    };
  } else if (scanFor.length > 0 && selectedText.match(scanFor)) {
    suffixToUse = suffixToUse.replace(replaceNext, selectedText);

    var _replacementText2 = prefixToUse + suffixToUse;

    selectionStart = selectionEnd = selectionStart + prefixToUse.length;
    return {
      text: _replacementText2,
      selectionStart: selectionStart,
      selectionEnd: selectionEnd
    };
  } else {
    var _replacementText3 = prefixToUse + selectedText + suffixToUse;

    selectionStart = selectionStart + prefixToUse.length + selectedText.length + suffixToUse.indexOf(replaceNext);
    selectionEnd = selectionStart + replaceNext.length;
    return {
      text: _replacementText3,
      selectionStart: selectionStart,
      selectionEnd: selectionEnd
    };
  }
}

function multilineStyle(textarea, arg) {
  var prefix = arg.prefix,
      suffix = arg.suffix,
      surroundWithNewlines = arg.surroundWithNewlines;
  var text = textarea.value.slice(textarea.selectionStart, textarea.selectionEnd);
  var selectionStart = textarea.selectionStart;
  var selectionEnd = textarea.selectionEnd;
  var lines = text.split('\n');
  var undoStyle = lines.every(function (line) {
    return line.startsWith(prefix) && line.endsWith(suffix);
  });

  if (undoStyle) {
    text = lines.map(function (line) {
      return line.slice(prefix.length, line.length - suffix.length);
    }).join('\n');
    selectionEnd = selectionStart + text.length;
  } else {
    text = lines.map(function (line) {
      return prefix + line + suffix;
    }).join('\n');

    if (surroundWithNewlines) {
      var _newlinesToSurroundSe = newlinesToSurroundSelectedText(textarea),
          newlinesToAppend = _newlinesToSurroundSe.newlinesToAppend,
          newlinesToPrepend = _newlinesToSurroundSe.newlinesToPrepend;

      selectionStart += newlinesToAppend.length;
      selectionEnd = selectionStart + text.length;
      text = newlinesToAppend + text + newlinesToPrepend;
    }
  }

  return {
    text: text,
    selectionStart: selectionStart,
    selectionEnd: selectionEnd
  };
}

function undoOrderedListStyle(text) {
  var lines = text.split('\n');
  var orderedListRegex = /^\d+\.\s+/;
  var shouldUndoOrderedList = lines.every(function (line) {
    return orderedListRegex.test(line);
  });
  var result = lines;

  if (shouldUndoOrderedList) {
    result = lines.map(function (line) {
      return line.replace(orderedListRegex, '');
    });
  }

  return {
    text: result.join('\n'),
    processed: shouldUndoOrderedList
  };
}

function undoUnorderedListStyle(text) {
  var lines = text.split('\n');
  var unorderedListPrefix = '- ';
  var shouldUndoUnorderedList = lines.every(function (line) {
    return line.startsWith(unorderedListPrefix);
  });
  var result = lines;

  if (shouldUndoUnorderedList) {
    result = lines.map(function (line) {
      return line.slice(unorderedListPrefix.length, line.length);
    });
  }

  return {
    text: result.join('\n'),
    processed: shouldUndoUnorderedList
  };
}

function makePrefix(index, unorderedList) {
  if (unorderedList) {
    return '- ';
  } else {
    return "".concat(index + 1, ". ");
  }
}

function clearExistingListStyle(style, selectedText) {
  var undoResultOpositeList;
  var undoResult;
  var pristineText;

  if (style.orderedList) {
    undoResult = undoOrderedListStyle(selectedText);
    undoResultOpositeList = undoUnorderedListStyle(undoResult.text);
    pristineText = undoResultOpositeList.text;
  } else {
    undoResult = undoUnorderedListStyle(selectedText);
    undoResultOpositeList = undoOrderedListStyle(undoResult.text);
    pristineText = undoResultOpositeList.text;
  }

  return [undoResult, undoResultOpositeList, pristineText];
}

function listStyle(textarea, style) {
  var noInitialSelection = textarea.selectionStart === textarea.selectionEnd;
  var selectionStart = textarea.selectionStart;
  var selectionEnd = textarea.selectionEnd;
  expandSelectionToLine(textarea);
  var selectedText = textarea.value.slice(textarea.selectionStart, textarea.selectionEnd);

  var _clearExistingListSty = clearExistingListStyle(style, selectedText),
      _clearExistingListSty2 = _slicedToArray(_clearExistingListSty, 3),
      undoResult = _clearExistingListSty2[0],
      undoResultOpositeList = _clearExistingListSty2[1],
      pristineText = _clearExistingListSty2[2];

  var prefixedLines = pristineText.split('\n').map(function (value, index) {
    return "".concat(makePrefix(index, style.unorderedList)).concat(value);
  });
  var totalPrefixLength = prefixedLines.reduce(function (previousValue, _currentValue, currentIndex) {
    return previousValue + makePrefix(currentIndex, style.unorderedList).length;
  }, 0);
  var totalPrefixLengthOpositeList = prefixedLines.reduce(function (previousValue, _currentValue, currentIndex) {
    return previousValue + makePrefix(currentIndex, !style.unorderedList).length;
  }, 0);

  if (undoResult.processed) {
    if (noInitialSelection) {
      selectionStart = Math.max(selectionStart - makePrefix(0, style.unorderedList).length, 0);
      selectionEnd = selectionStart;
    } else {
      selectionStart = textarea.selectionStart;
      selectionEnd = textarea.selectionEnd - totalPrefixLength;
    }

    return {
      text: pristineText,
      selectionStart: selectionStart,
      selectionEnd: selectionEnd
    };
  }

  var _newlinesToSurroundSe2 = newlinesToSurroundSelectedText(textarea),
      newlinesToAppend = _newlinesToSurroundSe2.newlinesToAppend,
      newlinesToPrepend = _newlinesToSurroundSe2.newlinesToPrepend;

  var text = newlinesToAppend + prefixedLines.join('\n') + newlinesToPrepend;

  if (noInitialSelection) {
    selectionStart = Math.max(selectionStart + makePrefix(0, style.unorderedList).length + newlinesToAppend.length, 0);
    selectionEnd = selectionStart;
  } else {
    if (undoResultOpositeList.processed) {
      selectionStart = Math.max(textarea.selectionStart + newlinesToAppend.length, 0);
      selectionEnd = textarea.selectionEnd + newlinesToAppend.length + totalPrefixLength - totalPrefixLengthOpositeList;
    } else {
      selectionStart = Math.max(textarea.selectionStart + newlinesToAppend.length, 0);
      selectionEnd = textarea.selectionEnd + newlinesToAppend.length + totalPrefixLength;
    }
  }

  return {
    text: text,
    selectionStart: selectionStart,
    selectionEnd: selectionEnd
  };
}

function applyStyle(button, stylesToApply) {
  var toolbar = button.closest('markdown-toolbar');
  if (!(toolbar instanceof MarkdownToolbarElement)) return;
  var defaults = {
    prefix: '',
    suffix: '',
    blockPrefix: '',
    blockSuffix: '',
    multiline: false,
    replaceNext: '',
    prefixSpace: false,
    scanFor: '',
    surroundWithNewlines: false,
    orderedList: false,
    unorderedList: false,
    trimFirst: false
  };
  var style = Object.assign(Object.assign({}, defaults), stylesToApply);
  var field = toolbar.field;

  if (field) {
    field.focus();
    styleSelectedText(field, style);
  }
}

export default MarkdownToolbarElement;